<template>
  <div class="overlay">
    <div class="delete-modal">
      <div>
        <h3>Delete {{ objectName }}</h3>
        <div class="warning">
          <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
            <path d="M0 0h24v24H0z" fill="none" />
            <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" fill="#de7d7d" />
          </svg>
          <p><span>Warning:</span> this action is irreversible!</p>
        </div>
        <div class="confirm">
          <p>
            Please type <span data-cy="object-id">{{ objectId }}</span> to confirm.
          </p>
          <input class="input" id="id" v-model="confirmedId" data-cy="confirm-id" />
          <div class="actions">
            <span class="action action--cancel" :class="{ active: match }" @click="onClose">Cancel</span>
            <span class="action action--delete" :class="{ active: match }" @click="confirmDelete()" data-cy="confirm-button">Delete {{ objectName }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      confirmedId: '',
    }
  },
  props: {
    objectName: String,
    objectId: String,
    eventName: String,
  },
  methods: {
    onClose() {
      this.$emit(`update:${this.eventName}`, false)
    },
    confirmDelete() {
      if (this.confirmedId === this.objectId) return this.$emit('deleted', true)

      this.$notify({
        text: 'IDs do not match',
        type: 'error',
      })
    },
  },
  computed: {
    match() {
      return this.confirmedId === this.objectId
    },
  },
}
</script>
<style lang="scss" scoped>
@import '../assets/shared-styles/button.scss';
@import '../assets/shared-styles/input.scss';
@import '../assets/shared-styles/textarea.scss';

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 50;
  background: rgba(0, 0, 0, 0.6);
}

.delete-modal {
  position: fixed;
  width: 400px;
  z-index: 100;
  left: 50%;
  top: 50%;
  background: white;
  transform: translate(-50%, -50%);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
  padding: 2em;
  h3 {
    margin-top: 0;
  }
}

.warning {
  display: flex;
  align-items: center;
  svg {
    margin-right: 0.5rem;
  }
  p {
    margin: 0;
    color: var(--color-danger);
    span {
      font-weight: 600;
    }
  }
}

.confirm {
  margin-top: 1rem;
  p {
    span {
      font-weight: 600;
    }
  }
}

.actions {
  display: grid;
  float: right;
  grid-template-columns: 1fr auto;
  gap: 1rem;
  margin-top: 2rem;
}

.action {
  font-weight: 700;
  text-transform: uppercase;
  font-size: 0.9375rem;
  cursor: pointer;
}
.action--delete {
  color: var(--color-danger);
  &:hover {
    color: #db6f6f;
  }
}
.action--cancel {
  opacity: 0.5;
  &:hover {
    opacity: 0.6;
  }
}
</style>
